import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import Icon from './Icon';
type SearchModalHeaderProps = {
  onClose?: () => void;
  closeText?: string;
  className?: string;
};
export default function SearchModalHeader(t0) {
  const $ = _c(8);
  const {
    onClose,
    closeText,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cx("px-16", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== closeText || $[3] !== onClose) {
    t2 = onClose && <div className="flex justify-end"><button type="button" onClick={onClose} className="inline-flex items-center">{closeText && <p className="mr-1.5 text-base font-bold text-white">{closeText}</p>}<Icon name="close" className="text-white" size="xs" /></button></div>;
    $[2] = closeText;
    $[3] = onClose;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}